import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type TransferConversationModalStore } from '../store/transferConversationModalStore'

export const TransferConversationModalActions = observer(
  ({ store }: { store: TransferConversationModalStore }) => (
    <Button
      typeBtn={'contained'}
      text={'Transfer'}
      onClick={store.onTransfer}
      disabled={!!store.inboxError || !!store.organizationError}
      loading={store.loading}
    />
  )
)
